function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 46,
  rx: 6,
  fill: "#FF6D4C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.25 13H31.75C33.8175 13 35.5 14.6825 35.5 16.75V29.25C35.5 31.3175 33.8175 33 31.75 33H14.25C12.1825 33 10.5 31.3175 10.5 29.25V16.75C10.5 14.6825 12.1825 13 14.25 13ZM30.9163 15.5L23 21.4375L15.0837 15.5H30.9163ZM14.25 30.5C13.5612 30.5 13 29.94 13 29.25V17.0625L22.25 24C22.4725 24.1675 22.7362 24.25 23 24.25C23.2638 24.25 23.5275 24.1675 23.75 24L33 17.0625V29.25C33 29.94 32.4387 30.5 31.75 30.5H14.25Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.25 13H31.75C33.8175 13 35.5 14.6825 35.5 16.75V29.25C35.5 31.3175 33.8175 33 31.75 33H14.25C12.1825 33 10.5 31.3175 10.5 29.25V16.75C10.5 14.6825 12.1825 13 14.25 13ZM30.9163 15.5L23 21.4375L15.0837 15.5H30.9163ZM14.25 30.5C13.5612 30.5 13 29.94 13 29.25V17.0625L22.25 24C22.4725 24.1675 22.7362 24.25 23 24.25C23.2638 24.25 23.5275 24.1675 23.75 24L33 17.0625V29.25C33 29.94 32.4387 30.5 31.75 30.5H14.25Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_39940_11172)"
});

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39940_11172",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 13,
    width: 26,
    height: 20
  }, _ref4), _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f9eba718.svg";
export { ForwardRef as ReactComponent };